<script setup lang="ts">
import imgUrl from './assets/clinishift-banner-wordmark-dark.png'

defineProps<{
  message: string
}>()
</script>

<template>
  <div
    data-theme="brand"
    class="z-50 absolute inset-0 min-h-screen flex flex-col items-center justify-between py-12 bg-surface-raised"
  >
    <div class="flex-1 flex items-center justify-center">
      <div class="flex flex-col items-center gap-12">
        <div class="w-full max-w-96 px-6">
          <img :src="imgUrl" alt="clinishift-logo" class="w-full h-full" />

          <h2
            class="mt-6 text-on-surface text-center text-2xl font-barlow font-semibold"
          >
            {{ message }}
          </h2>
        </div>

        <div class="w-full flex justify-around items-end">
          <i class="animate-bounce pi pi-building text-status-success text-[4rem]" />
          <i class="animate-bounce pi pi-heart text-kind-time-off text-[6rem]" />
          <i
            class="animate-bounce pi pi-building text-kind-availability text-[4rem]"
          />
        </div>
      </div>
    </div>

    <div>
      <ProgressSpinner
        class="size-[50px]"
        stroke-width="8"
        fill="transparent"
        aria-label="Loading Progress Spinner"
        data-testid="loading-progress-spinner"
      />
    </div>
  </div>
</template>
